import type { TranslationDict } from '../en';

const pt: TranslationDict = {
  'header.buy': 'Comprar',
  'header.sell': 'Vender',
  'spend.label': 'Você gasta',
  'spend.placeholderFiat': '250',
  'spend.placeholderCrypto': '0.01',
  'receive.label': 'Você recebe',
  'payment.label': 'Método de pagamento',
  'payment.select': 'Selecionar',
  'provider.label': 'By',
  'provider.select': 'Select',
  'provider.unavailable': 'Unavailable',
  'provider.unavailablePayment': 'Payment method not supported',
  'provider.unavailableCountry': 'Region not supported',
  'provider.unavailableCurrency': 'Currency not supported',
  'provider.unavailableNetwork': 'Network not supported',
  'payment.noneAvailable': 'Nenhum método de pagamento para este par',
  'wallet.label': 'Endereço da carteira de recebimento',
  'wallet.placeholderBuy': 'Insira seu endereço de recebimento',
  'wallet.placeholderSell': 'Insira seu endereço de envio',
  'wallet.validating': 'Validando endereço...',
  'wallet.invalid': 'Insira um endereço de carteira válido',
  'wallet.invalidServer': 'Endereço de carteira inválido',
  'cta.buy': 'Comprar {crypto}',
  'cta.sell': 'Vender {crypto}',
  'cta.gettingPrice': 'Obtendo melhor preço...',
  'cta.processing': 'Processando...',
  'footer.poweredBy': 'Desenvolvido por ',
  'footer.brand': 'NowRamp',
  'rate.title': 'Detalhamento da taxa',
  'rate.close': 'Fechar',
  'rate.updatesIn': 'Taxa atualiza em 00:{seconds}',
  'rate.noQuote': 'Nenhuma cotação disponível',
  'rate.exchangeRate': 'Taxa de câmbio',
  'rate.processingFee': 'Taxa de processamento',
  'rate.networkFee': 'Taxa de rede',
  'rate.provider': 'Provedor',
  'toast.orderCreated': 'Pedido criado',
  'toast.redirecting': 'Redirecionando para o checkout...',
  'toast.orderFailed': 'Pedido falhou',
  'toast.couldNotCreate': 'Não foi possível criar o pedido',
  'toast.quoteError': 'Erro de cotação',
  'toast.noProviders': 'Sem provedores',
  'toast.somethingWrong': 'Algo deu errado',
  'error.amountZero': 'O valor deve ser maior que 0',
  'error.minAmountFiat': 'O valor mínimo é {min} {currency}',
  'error.minAmountCrypto': 'O valor mínimo é {min} {currency}',
  'error.noProviders': 'Nenhum provedor disponível para esta combinação',
  'error.currencyUnavailableBuy': 'Esta moeda não está disponível para compras',
  'error.currencyUnavailableSell': 'Esta moeda não está disponível para vendas',
  'parity.info': 'Você será cobrado por {receiveAmount} {crypto}, o restante até {spendAmount} {fiat} será creditado na sua conta {partner}',
  'redirect.secureBadge': 'Pagamento seguro',
  'redirect.title': 'Continuar pagamento',
  'redirect.description': 'Você será redirecionado para {gateway} para concluir seu pagamento.',
  'redirect.countdown': 'Redirecionando em {seconds}...',
  'redirect.openTab': 'Abrir ACH em nova aba',
  'redirect.cancel': 'Cancelar',
  'checkout.noOrder': 'Nenhum pedido encontrado',
  'checkout.goBack': 'Voltar',
  'checkout.expired': 'Checkout expirado',
  'checkout.expiredDesc': 'A sessão expirou. Por favor, tente novamente.',
  'checkout.startOver': 'Recomeçar',
  'checkout.cancel': 'Cancelar',
  'checkout.loading': 'Carregando checkout...',
  'checkout.iframeTitle': 'Checkout do provedor',
  'checkout.widgetTitle': 'Checkout de pagamento',
  'checkout.unknownMethod': 'Método de checkout desconhecido',
  'processing.default': 'Processando seu pedido...',
  'processing.pending': 'Aguardando confirmação de pagamento...',
  'processing.active': 'Processando sua transação...',
  'processing.generic': 'Processando...',
  'processing.checkingStatus': 'Verificando status...',
  'processing.orderId': 'ID do pedido',
  'processing.provider': 'Provedor',
  'processing.amount': 'Valor',
  'processing.receiving': 'Recebendo',
  'processing.network': 'Rede',
  'processing.toAddress': 'Endereço de destino',
  'processing.usuallyMinutes': 'Isso geralmente leva alguns minutos.',
  'processing.safeToClose': 'Você pode fechar esta página com segurança - enviaremos um e-mail quando estiver concluído.',
  'complete.buyTitle': 'Compra concluída!',
  'complete.sellTitle': 'Venda concluída!',
  'complete.buyDesc': 'Seus {crypto} foram enviados para sua carteira.',
  'complete.sellDesc': 'Seu pagamento em {fiat} está sendo processado.',
  'complete.amountBuy': 'Valor recebido',
  'complete.amountSell': 'Valor vendido',
  'complete.paidBuy': 'Valor pago',
  'complete.paidSell': 'Valor do pagamento',
  'complete.network': 'Rede',
  'complete.wallet': 'Carteira',
  'complete.transaction': 'Transação',
  'complete.provider': 'Provedor',
  'complete.orderId': 'ID do pedido',
  'complete.completed': 'Concluído',
  'complete.viewExplorer': 'Ver no explorador',
  'complete.done': 'Concluído',
  'errorStep.failed': 'Pagamento falhou',
  'errorStep.cancelled': 'Pedido cancelado',
  'errorStep.expired': 'Pedido expirado',
  'errorStep.refunded': 'Pedido reembolsado',
  'errorStep.unknown': 'Algo deu errado',
  'errorStep.failedBuy': 'Seu pagamento não pôde ser processado. Por favor, tente novamente ou use outro método de pagamento.',
  'errorStep.failedSell': 'Sua venda não pôde ser processada. Por favor, tente novamente.',
  'errorStep.cancelledBuy': 'Seu pedido foi cancelado. Nenhum pagamento foi processado.',
  'errorStep.cancelledSell': 'Sua venda foi cancelada. Nenhuma criptomoeda foi transferida.',
  'errorStep.expiredBuy': 'Seu pedido expirou. Por favor, inicie uma nova compra.',
  'errorStep.expiredSell': 'Seu pedido expirou. Por favor, inicie uma nova venda.',
  'errorStep.refundedBuy': 'Seu pagamento foi reembolsado. Os fundos aparecerão na sua conta em 5 a 10 dias úteis.',
  'errorStep.refundedSell': 'Suas criptomoedas foram devolvidas. Os fundos aparecerão na sua carteira em breve.',
  'errorStep.genericDesc': 'Ocorreu um erro inesperado. Por favor, tente novamente.',
  'errorStep.orderId': 'ID do pedido',
  'errorStep.tryAgain': 'Tentar novamente',
  'errorStep.startOver': 'Recomeçar',
  'errorStep.return': 'Voltar',
  'errorStep.needHelp': 'Precisa de ajuda? Contate ',
  'errorStep.reference': 'Referência: {orderId}',
  'confirm.buyTitle': 'Confirmar compra',
  'confirm.sellTitle': 'Confirmar venda',
  'confirm.loading': 'Carregando...',
  'confirm.provider': 'Provedor',
  'confirm.youPay': 'Você paga',
  'confirm.youSell': 'Você vende',
  'confirm.youReceive': 'Você recebe',
  'confirm.wallet': 'Carteira',
  'confirm.network': 'Rede',
  'confirm.refundAddress': 'Endereço de reembolso',
  'confirm.parityNote': 'O valor cobrado pelo provedor pode diferir. O restante até {amount} {crypto} será creditado na sua conta {partner}.',
  'confirm.processing': 'Processando...',
  'confirm.confirmPay': 'Confirmar e pagar',
  'confirm.confirmSell': 'Confirmar e vender',
  'confirm.payout': 'Pagamento em {currency}',
  'modal.selectFiat': 'Selecionar moeda fiat',
  'modal.selectCrypto': 'Selecionar criptomoeda',
  'modal.choosePayment': 'Escolher método de pagamento',
  'modal.selectCountry': 'Selecione seu país',
  'modal.selectLanguage': 'Select language',
  'modal.popular': 'Popular',
  'modal.recommended': 'Recomendado',
  'modal.noCurrencies': 'Nenhuma moeda encontrada',
  'modal.noPaymentMethods': 'Nenhum método de pagamento encontrado',
  'modal.noCountries': 'Nenhum país encontrado',
  'modal.noLanguages': 'No languages found',
  'settings.location': 'Localização',
  'settings.darkMode': 'Modo escuro',
  'settings.privacy': 'Política de privacidade',
  'settings.terms': 'Termos de uso',
  'settings.language': 'Idioma',
  // ─── Additional ───
  'modal.chooseRamp': 'Escolher Ramp',
  'modal.bestPrice': 'Melhor preço',
  'modal.noQuotes': 'Nenhuma cotação disponível para esta solicitação',
  'modal.noProvidersFound': 'Nenhum provedor encontrado',
  'payment.unavailableFor': 'Nenhum método de pagamento disponível para {currency}',
  'skeleton.poweredBy': 'Desenvolvido por NowRamp',
  'error.createOrderFailed': 'Falha ao criar pedido',
  'errorStep.returnToMerchant': 'Voltar ao comerciante',
  'confirm.cryptoOnNetwork': '{crypto} na {network}',
  'payment.name.card': 'Cartão',
  'payment.name.bankTransfer': 'Transferência bancária',
  'payment.name.ach': 'ACH',
  'rate.updatesInLabel': 'Rate updates in',
  'rate.networkFeeIncl': 'Network fee incl.',
  'rate.rateTooltip': 'As the market is highly volatile, we can fix the exchange rate for no longer than 30 seconds.',
  'rate.networkFeeTooltip': 'Includes a fee charged by blockchain to execute the transaction.',
  'rate.feeIncluded': '{percentage}% incl.',
  'receive.fetchingRate': 'Fetching best rate...',
  'redirect.tabHelper': 'If the new tab has not opened, click the button above.',
};

export default pt;
